// Shared utilities for PreachKit panels
import axios from "axios";
import { toast } from "sonner";
import { getErrorMessage } from "../../utils/errorHandler";

export const API = process.env.REACT_APP_BACKEND_URL;

export const TRANSLATIONS = [
  { value: "kjv", label: "KJV - King James Version" },
  { value: "web", label: "WEB - World English Bible" },
  { value: "asv", label: "ASV - American Standard" },
  { value: "bbe", label: "BBE - Bible in Basic English" },
];

export const TONES = ["encouraging", "expository", "prophetic", "evangelistic"];
export const LENGTHS = ["short", "medium", "long"];

export function authHeader() {
  const token = localStorage.getItem("token");
  return { Authorization: `Bearer ${token}` };
}

/**
 * Convert a PreachKit sermon (outline / slides / notes) into a real SlideCon
 * project and navigate the user into the Editor.
 */
export async function sendSermonToEditor({ title, sermon_type, content, navigate, t }) {
  try {
    const res = await axios.post(
      `${API}/api/pulpit/send-to-editor`,
      { title, sermon_type, content },
      { headers: authHeader() }
    );
    toast.success(t("project_created") || "Project created");
    navigate(`/editor/${res.data.project_id}`);
    return res.data;
  } catch (err) {
    toast.error(getErrorMessage(err, t("send_failed") || "Send failed"));
    return null;
  }
}
